import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919353548879?text=Hi%2C%20I%20am%20interested%20in%20the%20internship%20programs%20at%20Scontinent%20Technologies."
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      style={{
        position: "fixed",
        bottom: "28px",
        right: "28px",
        zIndex: 9998,
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 24px rgba(37,211,102,0.45)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.boxShadow = "0 10px 32px rgba(37,211,102,0.6)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(37,211,102,0.45)";
      }}
    >
      {/* WhatsApp SVG icon */}
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.5L4 29l7.697-1.813A11.94 11.94 0 0016 28c6.627 0 12-5.373 12-12S22.627 3 16 3z"
          fill="white"
        />
        <path
          d="M21.844 19.116c-.292-.146-1.724-.851-1.991-.948-.267-.097-.461-.146-.655.146-.194.292-.754.948-.924 1.142-.17.195-.34.219-.632.073-.292-.146-1.233-.454-2.348-1.449-.867-.774-1.452-1.729-1.622-2.021-.17-.292-.018-.45.128-.595.131-.13.292-.34.438-.51.146-.17.194-.292.292-.486.097-.195.049-.365-.025-.51-.073-.146-.655-1.578-.897-2.161-.236-.568-.477-.49-.655-.499-.17-.008-.365-.01-.56-.01-.194 0-.51.073-.777.365-.267.292-1.02.997-1.02 2.43 0 1.433 1.044 2.817 1.19 3.011.146.195 2.055 3.138 4.981 4.401.696.3 1.239.48 1.663.614.699.222 1.335.19 1.837.115.56-.084 1.724-.705 1.967-1.386.243-.681.243-1.265.17-1.386-.073-.122-.267-.195-.56-.34z"
          fill="#25D366"
        />
      </svg>
    </a>
  );
}
import Home from "@/pages/Home";
import About from "@/pages/About";
import Internships from "@/pages/Internships";
import InternshipDetail from "@/pages/InternshipDetail";
import Services from "@/pages/Services";
import SamAI from "@/pages/SamAI";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import Admin from "@/pages/Admin";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/internships/:slug" element={<InternshipDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/samai" element={<SamAI />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
